import { Directive, HostListener, ViewContainerRef, input } from '@angular/core';
import { PlaceholderOverlayComponent, PlaceholderSet } from '../components/placeholder-overlay/placeholder-overlay.component';

@Directive({
  selector: '[appPlaceholderInfo]',
  standalone: true
})
export class PlaceholderInfoDirective {
  public readonly set = input<PlaceholderSet>('basic', { alias: "appPlaceholderInfo" });

  private overlayRef: PlaceholderOverlayComponent | null = null;

  constructor(private vcr: ViewContainerRef) { }

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent) {
    event.stopPropagation();
    if (!this.overlayRef) {
      const ref = this.vcr.createComponent(PlaceholderOverlayComponent);
      this.overlayRef = ref.instance;
      this.overlayRef.set = this.set();
    }
    this.overlayRef.visible = true;
  }
}
